import React from "react";
import "./TileComponent.scss";

const TileComponent = ({ type, title, number }) => {
  return (
    <div className={`${type} tile`}>
      <div className="tile-header">{number | 0}</div>
      <div className="tile-body">{title}</div>
    </div>
  );
};

export default TileComponent;
